import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Grid,
  MenuItem,
  Button,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { vendorApi } from '../../api/api';

const EditVillaDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [priceMode, setPriceMode] = useState("");

  const { propertyData, PropertyType, sqftamount, percentagevalue } = location.state || {};
  const [formValues, setFormValues] = useState({
    PropertyName: propertyData.PropertyName,
    Address: propertyData.Address,
    percentagevalue: percentagevalue ?? "",
    sqftamount: sqftamount ?? "",
    City: propertyData.City,
    AgeOfBuilding: propertyData.ExtraData.AgeOfBuilding,
    Bedrooms: propertyData.ExtraData.Bedrooms,
    Bathrooms: propertyData.ExtraData.Bathrooms,
    Balcony: propertyData.ExtraData.Balcony,
    NoOfFloors: propertyData.ExtraData.NoOfFloors,
     Description: propertyData.Description || [],
    Facing: propertyData.Facing,
    LandAreaInSqFt: propertyData.ExtraData.LandAreaInSqFt,
    SizeInSqFt: propertyData.SizeInSqFt,
    MarketPrice: propertyData.CurrentValue,
    WaterSupply: propertyData.ExtraData.WaterSupply,
    PowerBackUp: propertyData.ExtraData.PowerBackUp,
    ParkingAvailable: propertyData.ExtraData.ParkingAvailable,
    ParkingType: propertyData.ExtraData.ParkingType,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePriceModeChange = (e) => {
    const mode = e.target.value;
    setPriceMode(mode);

    setFormValues((prev) => ({
      ...prev,
      percentagevalue: mode === "percentage" ? prev.percentagevalue : "",
      sqftamount: mode === "sqft" ? prev.sqftamount : "",
    }));
  };


  useEffect(() => {
    if (percentagevalue !== null && percentagevalue !== undefined && percentagevalue !== "") {
      setPriceMode("percentage");
    } else if (sqftamount !== null && sqftamount !== undefined && sqftamount !== "") {
      setPriceMode("sqft");
    }
  }, [percentagevalue, sqftamount]);



  const handleSubmit = async () => {
    const payload = {
      Pid: propertyData.Pid || propertyData.Id,
      PropertyName: formValues.PropertyName,
      PropertyType: PropertyType,
      Address: formValues.Address,
      City: formValues.City,
      GeoLocation: null,
      SizeInSqFt: formValues.SizeInSqFt,
      Facing: formValues.Facing,

      // convert to number if not empty, else null
    percentagevalue:
      formValues.percentagevalue === "" ? null : Number(formValues.percentagevalue),
    sqftamount:
      formValues.sqftamount === "" ? null : Number(formValues.sqftamount),
   Description: formValues.Description.filter(
      d => d && d.trim() !== ""
    ),
      ExtraData: {
        AgeOfBuilding: formValues.AgeOfBuilding,
        Bedrooms: formValues.Bedrooms,
        Bathrooms: formValues.Bathrooms,
        Balcony: formValues.Balcony,
        NoOfFloors: formValues.NoOfFloors,
        WaterSupply: formValues.WaterSupply,
        PowerBackUp: formValues.PowerBackUp,
        ParkingAvailable: formValues.ParkingAvailable,
        ParkingType: formValues.ParkingType,
        LandAreaInSqFt: formValues.LandAreaInSqFt,
      },
    };

    try {
      const res = await vendorApi.editVillaDetails(payload);
      alert('Villa updated successfully!');
       setTimeout(() => {
        navigate("/property");
      }, 2000);
    } catch (error) {
      console.error('Update failed:', error.response?.data || error.message);
      alert('Failed to update villa. Please try again.');
    }
  };
  const handleDescriptionChange = (index, value) => {
  const updated = [...formValues.Description];
  updated[index] = value;

  setFormValues(prev => ({
    ...prev,
    Description: updated
  }));
};

const addDescriptionPoint = () => {
  setFormValues(prev => ({
    ...prev,
    Description: [...prev.Description, ""]
  }));
};

const removeDescriptionPoint = (index) => {
  const updated = formValues.Description.filter((_, i) => i !== index);

  setFormValues(prev => ({
    ...prev,
    Description: updated
  }));
};



  return (
    <Paper elevation={3} sx={{ padding: 4, margin: 4 }}>
      <Typography variant="h5" gutterBottom>
        Edit Villa Details
      </Typography>

      <Box component="form">
        <Grid container spacing={2}>
          {[
            { label: 'Property Name', name: 'PropertyName' },
            { label: 'Address', name: 'Address' },
            { label: 'City', name: 'City' },
            { label: 'Age of Building', name: 'AgeOfBuilding' },
            { label: 'Bedrooms', name: 'Bedrooms' },
            { label: 'Bathrooms', name: 'Bathrooms' },
            { label: 'Balcony', name: 'Balcony' },
            { label: 'No. of Floors', name: 'NoOfFloors' },
            { label: 'Facing', name: 'Facing' },
            { label: 'Land Area (sq ft)', name: 'LandAreaInSqFt' },
            { label: 'Size (sq ft)', name: 'SizeInSqFt' },
            { label: 'Market Price', name: 'MarketPrice', disabled: true },
            { label: 'Water Supply', name: 'WaterSupply' },
            { label: 'Power Backup', name: 'PowerBackUp' },
          ].map((field) => (
            <Grid key={field.name} item xs={12} sm={6}>
              <TextField
                fullWidth
                label={field.label}
                name={field.name}
                value={formValues[field.name]}
                onChange={handleChange}
                disabled={field.disabled}
              />
            </Grid>
          ))}
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Price Type"
              value={priceMode}
              onChange={handlePriceModeChange}
            >


              <MenuItem value="percentage">Percentage (%)</MenuItem>
              <MenuItem value="sqft">Sqft Amount</MenuItem>
            </TextField>
          </Grid>
          {priceMode === "percentage" && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Percentage (%)"
                name="percentagevalue"
                value={formValues.percentagevalue}

                onChange={handleChange}
              />
            </Grid>
          )}
          {priceMode === "sqft" && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Sqft Amount"
                name="sqftamount"
                value={formValues.sqftamount}

                onChange={handleChange}
              />
            </Grid>
          )}

          {/* Parking Available */}
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Parking Available"
              name="ParkingAvailable"
              value={formValues.ParkingAvailable}
              onChange={handleChange}
            >
              <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="no">No</MenuItem>
            </TextField>
          </Grid>

          {/* Parking Type */}
          {formValues.ParkingAvailable === 'yes' && (
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Parking Type"
                name="ParkingType"
                value={formValues.ParkingType}
                onChange={handleChange}
              >
                <MenuItem value="bike">Bike</MenuItem>
                <MenuItem value="car">Car</MenuItem>
                <MenuItem value="both">Both</MenuItem>
              </TextField>
            </Grid>
          )}
        </Grid>
{/* Description Points */}
<Grid item xs={12}>
  <Typography variant="h6">Description</Typography>
</Grid>

{formValues.Description.map((desc, index) => (
  <Grid item xs={12} key={index} mt={2} >
    <Box display="flex" gap={2}>
      <TextField
        fullWidth
        multiline
        minRows={2}
        label={`Description ${index + 1}`}
        value={desc}
        onChange={(e) =>
          handleDescriptionChange(index, e.target.value)
        }
      />
      <Button
        color="error"
        onClick={() => removeDescriptionPoint(index)}
      >
        Remove
      </Button>
    </Box>
  </Grid>
))}

<Grid item xs={12} mt={2}>
  <Button variant="outlined" onClick={addDescriptionPoint}>
    + Add Description Point
  </Button>
</Grid>

        {/* Save Button */}
        <Grid item xs={12} sx={{ marginTop: 3, display: 'flex', justifyContent: 'flex-end', gap: 3 }}>
          <Button variant='outlined' onClick={() => navigate(-1)}> Cancel </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ width: '200px' }}
          >
            Save Changes
          </Button>
        </Grid>
      </Box>
    </Paper>
  );
};

export default EditVillaDetails;
